import { VideoPublisherAction, VideoPublisherState, VideoPublisherStatus, VideoPublisherStep } from '@core/swagger-client';
import { Button, Dialog, LoaderDots } from '@core/ui';
import { useTranslation } from 'react-i18next';

export const PublishingDialogOrganism = ({ state, onClose, open }: { state: VideoPublisherState; onClose: () => void; open: boolean }) => {
    const { t } = useTranslation();
    const canClose = !state || state.status !== VideoPublisherStatus.Publishing;

    return (
        <Dialog open={open} onClose={canClose ? onClose : undefined} title={t(`Editor.Publishing.Modal.${VideoPublisherAction[state.action]}Header`)}>
            <div className="flex flex-col justify-start">
                <p className="mb-4">{t(`Editor.Publishing.Modal.${VideoPublisherAction[state.action]}Description`)}</p>
                {state.status === VideoPublisherStatus.Success && <p className="mb-6">{t('Editor.Publishing.Modal.Success')}</p>}
                {state.status === VideoPublisherStatus.Error && <p className="mb-6">{t('Editor.Publishing.Modal.Error', { error: state.error })}</p>}
                {state.status === VideoPublisherStatus.Publishing && (
                    <p className="mb-6">
                        {t(`Editor.Publishing.Modal.${VideoPublisherAction[state.action]}`)}
                        <LoaderDots classNames="relative bottom-[-.17em] h-[.625em] inline-block fill-current ms-1" />

                        <span className="block">{t(`Editor.Publishing.Modal.${VideoPublisherStep[state.step]}Step`)} {state.currentStep} / {state.totalSteps}</span>
                        <label htmlFor="progress-bar" className="mb-2">
                            {t('Editor.Publishing.Modal.Progress.Label')}
                        </label>
                        <progress id="progress-bar" className="progress" value={state.progress} max="100">
                            {state.progress}%
                        </progress>
                    </p>
                )}
                <Button variant="primary" isLoading={state.status === VideoPublisherStatus.Publishing} onClick={onClose}>
                    {t('Editor.Publishing.Modal.Close')}
                </Button>
            </div>
        </Dialog>
    );
};
